export default __webpack_public_path__ + "static/media/ae.3d45cc9f.png";